import React from 'react';

const IconMarker = () => (
  <svg
    className="uu-icon uu-icon-phone"
    viewBox="0 0 18 32"
  >
    <path d = "M13.714 11.429q0-1.893-1.339-3.232t-3.232-1.339-3.232 1.339-1.339 3.232 1.339 3.232 3.232 1.339 3.232-1.339 1.339-3.232zM18.286 11.429q0 1.946-0.589 3.196l-6.5 13.821q-0.286 0.589-0.848 0.929t-1.205 0.339-1.205-0.339-0.83-0.929l-6.518-13.821q-0.589-1.25-0.589-3.196 0-3.786 2.679-6.464t6.464-2.679 6.464 2.679 2.679 6.464z" ></path> { // eslint-disable-line
    }
  </svg>
);

export default IconMarker;



// WEBPACK FOOTER //
// ./public/js/components/Icons/IconMarker.jsx